import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler'

@Injectable({
  providedIn: 'root'
})
export class MobileReceiveVehicleFromPortService {
  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
  * Get all spare parts
  * @returns Observable<ApiResponse>
  */
  getVehicleSpareParts(): Observable<ApiResponse>
  {
    let apiURL:string=`${this.baseURL}/v1/spare-parts`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Receive vehicle from port/CFS
   * @param vehicleId
   * @param chassisNo
   * @param selectedSpareParts
   * @param needsRepair
   * @param comment
   * @param userId
   * @param locationId
   * @returns
   */
  receive(vehicleId: string, chassisNo: string, selectedSpareParts: any[],needsRepair:boolean,comment: string|null,userId:string,locationId:string): Observable<any> {

    let apiURL:string=`${this.baseURL}/v1/receive-vehicle-from-port`;

    const data = {
      vehicle_id: vehicleId,
      chassis_no:chassisNo,
      selected_spare_parts: selectedSpareParts,
      needs_repair:needsRepair,
      comment:comment,
      user_id:userId,
      location_id:locationId,
    };

    return this.http.post<any>(apiURL, data);
  }
}
